import { createBrowserClient } from '@supabase/ssr';

function createDummyClient() {
  const dummy: any = new Proxy(() => {}, {
    get(target, prop) {
      if (typeof prop === 'symbol') {
        return undefined;
      }
      if (prop === 'toString' || prop === 'toLocaleString') {
        return () => '[object DummySupabaseClient]';
      }
      if (prop === 'valueOf') {
        return () => 0;
      }
      if (prop === 'then') {
        return (resolve: any) => resolve({ data: null, error: null });
      }
      if (prop === 'auth') {
        return {
          getSession: async () => ({ data: { session: null }, error: null }),
          onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
          signInWithPassword: async () => ({ error: new Error('Supabase not configured') }),
          signUp: async () => ({ error: new Error('Supabase not configured') }),
          signOut: async () => {},
        };
      }
      return dummy;
    },
    apply() {
      return dummy;
    }
  });
  return dummy;
}

export function createClient() {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('Supabase URL or Anon Key is missing. Database features will be unavailable, but client-side DPI conversion will work.');
    return createDummyClient();
  }

  try {
    return createBrowserClient(supabaseUrl, supabaseAnonKey);
  } catch (e) {
    console.error('Failed to initialize Supabase client:', e);
    return createDummyClient();
  }
}

// Export singleton instance
export const supabase = createClient();


